import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { InternalMyProfileService } from '../../services/my-profile.service';
import { Admin } from '../actions/admin.actions';
import { AdminStateInterface } from '../models/admin.model';

@Injectable()
@State<AdminStateInterface>({
    name: 'admin',
    defaults: {
        selectedCountries: [],
        selectedVehicle: null,
        vehicleDetails: null,
        userProfile: null,
        pagination: {
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            totalPages: 0
        },
        sort: ''
    }
})
export class AdminState {
    constructor(private myProfileService: InternalMyProfileService) { }

    @Action(Admin.UpdateSelectedCountries)
    updateSelectedCountries(ctx: StateContext<AdminStateInterface>, action: Admin.UpdateSelectedCountries) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            selectedCountries: action.payload.selectedCountries
        });
    }

    @Action(Admin.SelectVehicle)
    selectVehicle(ctx: StateContext<AdminStateInterface>, action: Admin.SelectVehicle) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            selectedVehicle: action.payload.selectedVehicle
        });
    }

    @Action(Admin.UpdateVehicleDetails)
    updateVehicleDetails(ctx: StateContext<AdminStateInterface>, action: Admin.UpdateVehicleDetails) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            vehicleDetails: action.payload.vehicleDetails
        });
    }

    @Action(Admin.LoadUserProfile)
    loadUserProfile(ctx: StateContext<AdminStateInterface>, action: Admin.LoadUserProfile) {
        return this.myProfileService.getUserProfile(action.accountId).pipe(
            tap((userProfile) => ctx.dispatch(new Admin.LoadUserProfileSuccess(userProfile))),
            catchError(error => {
                ctx.dispatch(new Admin.LoadUserProfileFail(error));
                return of(error);
            })
        );
    }

    @Action(Admin.LoadUserProfileSuccess)
    loadUserProfileSuccess(ctx: StateContext<AdminStateInterface>, action: Admin.LoadUserProfileSuccess) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            userProfile: action.userProfile
        });
    }

    @Action(Admin.LoadUserProfileFail)
    loadUserProfileFail(ctx: StateContext<AdminStateInterface>, action: Admin.LoadUserProfileFail) {
        // Optionally handle error state
    }

    @Action(Admin.UpdatePagination)
    updatePagination(ctx: StateContext<AdminStateInterface>, action: Admin.UpdatePagination) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            pagination: action.payload.pagination
        });
    }

    @Action(Admin.UpdateSort)
    updateSort(ctx: StateContext<AdminStateInterface>, action: Admin.UpdateSort) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            sort: action.payload.sort
        });
    }
}
